import { connect } from 'react-redux';
import { compose} from 'recompose';

import Level from './Level';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(Level);
